import React from 'react';
import {IControllerProps} from '../../../types/app.types';
import {WidgetProps} from 'yoshi-flow-editor-runtime';

const Context = React.createContext({} as IControllerProps);

export function useControllerProps(): IControllerProps {
  return React.useContext(Context);
}

export function ControllerContext({
  value,
  children,
}: {
  value: WidgetProps<IControllerProps>;
  children: React.ReactNode;
}) {
  return <Context.Provider value={value}>{children}</Context.Provider>;
}
